export default __webpack_public_path__ + "assets/340072058ba1135f2a8e3596c8bf84d8.jpeg";